// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useNavigate } from "react-router-dom";
import Map from '../map/Map';


const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow:1,
	},
	fullHeight: {
		height: 'calc(100vh - 64px)',
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
}));

export default function Signs(props) {
	const classes = useStyles();
	const {handleSend} = props;
	const [loaded, setLoaded] = React.useState(false);
	const [signsList, setSignsList] = React.useState([]);
  	React.useEffect(() => {
		if(!loaded){
			getSignsList();
		}
	});
	const getSignsList = () =>{
		setLoaded(true);
		handleSend({
			vso: 'signslist'
		}, (data) => {
			setSignsList(data.signs);
		});
	}
	let navigate = useNavigate();
	const handleClickPointer = (id) => {
		navigate("/sign/"+id);
	}
	const pointerColor = (sign) => {
		
		if(sign?.ip){
			let color = "";
			if(sign.amberAlert) return "#ff8400";
			switch(sign?.last_update_status){
				case 0: 
					return "#CC0000";
				case 1:
					return "#019701";
				case 2:
					return "#19fd04";
				default:
					color = "#05F";
			}
			return color;
		}
		return "#05F";
		
	}
	if(signsList.length === 0)
		return (
			<div className={classes.fullHeight}>
				<Box className={classes.advancedContent}>
					<Typography variant="h2" gutterBottom>Loading signs</Typography>
				</Box>
			</div>
		);
	
	return (
		<div className={classes.fullHeight}>
	  		<Map signs={signsList} onClick={handleClickPointer} pointerColor={pointerColor} />
		</div>
		
	);
	
}
